import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

export interface FilterSectionWrapperProps {
  /**
   * Optional component to display on top (e.g., DatePicker, SearchBox)
   */
  topComponent?: React.ReactNode;
  /**
   * Optional component to display on bottom (e.g., Action buttons, Additional filters)
   */
  bottomComponent?: React.ReactNode;
  /**
   * The filter items to display
   */
  children: React.ReactNode;
  /**
   * Custom sx styles
   */
  sx?: SxProps<Theme>;
}

/**
 * A wrapper component that handles general spacing for filter items with a consistent gap of 6px.
 * Can optionally display a top component (e.g., DatePicker, SearchBox) with 16px marginBottom.
 * Can optionally display a bottom component (e.g., Action buttons) with 16px marginTop.
 */
export const FilterSectionWrapper: React.FC<FilterSectionWrapperProps> = ({
  topComponent,
  bottomComponent,
  children,
  sx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        ...sx,
      }}
    >
      {topComponent && <Box sx={{ marginBottom: '10px' }}>{topComponent}</Box>}
      {children}
      {bottomComponent && <Box sx={{ marginTop: '10px' }}>{bottomComponent}</Box>}
    </Box>
  );
};
